export const ONE_TRUST_COOKIE_CONSENT_COOKIE = 'OptanonConsent';
